// Componente WebCam per sistema ExeDialog DDT2026
// Mostra immagine dalla telecamera con refresh periodico
import React, { useState, useEffect } from 'react';

// Indici telecamere:
// targa: 2
// cassone: 1
// cabina: 3 (deprecated)
const CAM_INDEX = {
    targa: 2,
    cassone: 1,
    cabina: 3
};

export function WebCam({ verificaData, target, camUrl: camUrlProp }) {
    const [timestamp, setTimestamp] = useState(Date.now());

    // Aggiorna timestamp ogni 2 secondi per refresh immagine
    useEffect(() => {
        const interval = setInterval(() => {
            setTimestamp(Date.now());
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    const camUrl = camUrlProp || verificaData?.valori_accessori?.ddt?.camUrl;
    
    if (!camUrl) {
        return null;
    }

    const camIndex = CAM_INDEX[target];
    if (!camIndex) {
        console.warn(`WebCam: target "${target}" non valido`);
        return null;
    }

    const imgUrl = `https://app.ghiaia.net${camUrl}${camIndex}.jpg?size=3&quality=4&t=${timestamp}`;

    return (
        <div className="mb-3">
            <label className="form-label">Telecamera {target}</label>
            <div>
                <img 
                    alt={`webcam ${target}`} 
                    className="img-fluid" 
                    src={imgUrl}
                />
            </div>
        </div>
    );
}
